/*
  Strickle 2.0 (October 21): the "Add a disc" row inside the buy box (blocks/sk-buy-addon.liquid).
  A tap picks one disc, a second tap takes it off. When the picked choice already holds a disc (none since the Set +
  Finishing Disc choice was dropped on October 21), that disc reads "In your box" and cannot be picked. While a disc is
  picked, the Add to cart words carry the total, on the buy box button and on the sticky bar, and "Buy it now" hides (it
  would skip the disc). On Add to cart (the button or the sticky bar, which clicks the same button) the disc goes to the
  cart first; then the theme's own add runs, so its cart drawer shows both lines.
*/
(function () {
  if (window.skAddonReady) return;
  window.skAddonReady = true;

  function money(cents, format) {
    var amount = cents / 100;
    var text = amount % 1 === 0 ? String(amount) : amount.toFixed(2);
    return (format || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, text);
  }

  // The whole product section, not only .product-information: the phone's sticky bar sits beside it in the same
  // section, so the total and the picked state must reach it too (October 21 audit).
  function scopeOf(el) {
    return el.closest('.shopify-section') || el.closest('.product-information') || document.body;
  }

  function dataOf(addon) {
    try {
      return JSON.parse(addon.querySelector('[data-sk-addon-data]').textContent);
    } catch (e) {
      return { prices: {} };
    }
  }

  function mainVariant(scope) {
    var checked = scope.querySelector('variant-picker input:checked');
    if (checked && checked.dataset.variantId) return String(checked.dataset.variantId);
    var idInput = scope.querySelector('form[action*="/cart/add"] [name="id"]');
    return idInput ? String(idInput.value) : '';
  }

  function picked(addon) {
    return addon.querySelector('.sk-addon__swatch[aria-pressed="true"]');
  }

  function update(addon) {
    var scope = scopeOf(addon);
    var data = dataOf(addon);
    var current = mainVariant(scope);
    var holder = addon.dataset.withVariant || '';
    addon.querySelectorAll('.sk-addon__swatch[data-included]').forEach(function (button) {
      var label = button.querySelector('.sk-addon__grit');
      var inBox = holder !== '' && current === String(holder);
      button.classList.toggle('is-in-box', inBox);
      if (inBox) {
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-disabled', 'true');
        if (label) label.textContent = data.inBox || 'In your box';
      } else {
        button.removeAttribute('aria-disabled');
        if (label && !button.disabled) label.textContent = label.dataset.gritLabel || label.textContent;
      }
    });
    var choice = picked(addon);
    var total = '';
    if (choice && choice.dataset.discPrice && data.prices && data.prices[current] != null) {
      total = ' · ' + money(Number(data.prices[current]) + Number(choice.dataset.discPrice), data.money);
    }
    scope.style.setProperty('--sk-addon-total', total ? JSON.stringify(total) : '""');
    scope.classList.toggle('sk-addon-picked', !!choice);
  }

  function updateAll() {
    document.querySelectorAll('[data-sk-addon]').forEach(update);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.sk-addon__swatch') : null;
    if (!button) return;
    var addon = button.closest('[data-sk-addon]');
    if (!addon || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    var wasOn = button.getAttribute('aria-pressed') === 'true';
    addon.querySelectorAll('.sk-addon__swatch').forEach(function (other) {
      other.setAttribute('aria-pressed', 'false');
    });
    if (!wasOn) button.setAttribute('aria-pressed', 'true');
    update(addon);
  });

  // a new choice in the picker: Dwell morphs the picker after a fetch, so look again a moment later too
  document.addEventListener(
    'change',
    function (event) {
      if (!event.target.closest || !event.target.closest('variant-picker')) return;
      updateAll();
      setTimeout(updateAll, 400);
      setTimeout(updateAll, 1200);
    },
    true
  );

  var passing = false;
  document.addEventListener(
    'submit',
    function (event) {
      if (passing) return;
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      var addon = scopeOf(form).querySelector('[data-sk-addon]');
      var choice = addon ? picked(addon) : null;
      if (!choice || !choice.dataset.discVariant) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var submitter = event.submitter && event.submitter.form === form ? event.submitter : undefined;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(choice.dataset.discVariant), quantity: 1 }] }),
      })
        .catch(function () {})
        .then(function () {
          passing = true;
          try {
            form.requestSubmit(submitter);
          } finally {
            passing = false;
          }
        });
    },
    true
  );

  updateAll();
  document.addEventListener('DOMContentLoaded', updateAll);
})();
